import type { FC } from "react";
import { Text } from "@uhg-harmony/react";
import "./publish-bar.css";

type PublishBarProps = {
  displayTemplateName: string;
  textProps?: Record<string, unknown>;
  templateId: string;
  actionLabel: string;
  formatDateTime: (date: Date) => string;
  templateUpdatedAt?: Date | null;
};

const PublishBar: FC<PublishBarProps> = ({
  displayTemplateName,
  textProps,
  templateId,
  actionLabel,
  formatDateTime,
  templateUpdatedAt,
}) => {
  return (
    <div className="publish-bar">
      {/* Left section: title */}
      <div className="publish-bar__left">
        <Text
          {...textProps}
          weight="bold"
          size="large"
          className="publish-bar__label"
        >
          Template ID
        </Text>

        <Text {...textProps} size="large" className="publish-bar__date">
          : {templateId}
        </Text>

        <Text
          {...textProps}
          size="large"
          weight="bold"
          className="publish-bar__label"
        >
             &nbsp;&nbsp;&nbsp;&nbsp;Name
        </Text>

        <Text {...textProps} size="large" className="publish-bar__date">
          : {displayTemplateName}
        </Text>
      </div>

      <div className="publish-bar__right">
        <Text
          {...textProps}
          weight="bold"
          size="large"
          className="publish-bar__label"
        >
          {actionLabel}:
        </Text>
        <Text size="large" className="publish-bar__date">
          {templateUpdatedAt ? formatDateTime(templateUpdatedAt) : "\u2014"}
        </Text>
      </div>
    </div>
  );
};

export default PublishBar;
